import { useNavigate, Link } from "react-router-dom";
import { LogOut, LayoutGrid } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const displayName = user?.fullName || user?.username || "Kullanıcı";
  const initials = displayName.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

  return (
    <header className="sticky top-0 z-30 w-full border-b border-slate-200 bg-white/90 backdrop-blur" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="navbar-brand">
          <div className="w-8 h-8 rounded-md bg-slate-900 text-white flex items-center justify-center font-black text-sm group-hover:bg-blue-600 transition-colors">A</div>
          <span className="font-black tracking-tighter text-lg text-slate-900 font-heading">ALTINGROSS</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          <Link to="/" className="text-sm font-medium text-slate-700 hover:text-blue-600 px-3 py-2 rounded-md hover:bg-slate-50 transition-colors flex items-center gap-2" data-testid="nav-tools-link">
            <LayoutGrid className="w-4 h-4" />
            Firma Araçları
          </Link>
        </nav>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-2 px-2" data-testid="user-menu-trigger">
              <Avatar className="h-8 w-8 border border-slate-200">
                <AvatarFallback className="bg-slate-100 text-slate-700 text-xs font-semibold">{initials}</AvatarFallback>
              </Avatar>
              <span className="hidden sm:inline text-sm font-medium text-slate-700">{displayName}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuLabel className="text-xs font-normal text-slate-500">
              Giriş yapıldı
              <div className="text-sm font-semibold text-slate-900 mt-0.5">{user?.email || user?.username}</div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} className="cursor-pointer text-red-600 focus:text-red-700" data-testid="logout-button">
              <LogOut className="w-4 h-4 mr-2" />
              Çıkış Yap
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default Navbar;
